module.exports = __webpack_public_path__ + "img/BE_BC_Front.0d5f4c0c.png";